import { rtdb } from '../../server/index'

export const writeProductData = async (user, table, storeID, products) => {
    try {
        await rtdb.ref(`SharedCart/${storeID}/${table}/${user}`).update({ products });
        return true;
    } catch (error) {
       return false;
    }
}

export const readProductData = async (table, storeID) => {
    try {
        const dbRef = rtdb.ref();
        const snapshot = await dbRef.child(`SharedCart/${storeID}/${table}`).once('value');
        if (snapshot.exists) {
            return snapshot.val();
        }
        return {};
    } catch (error) {
        return {};
    }
}

export const getDbRef = (storeID, table) => {
    return rtdb.ref(`SharedCart/${storeID}/${table}`);
}

export const removeOrder = async (storeID, table) => {
    try {
        await rtdb.ref(`SharedCart/${storeID}/${table}`).remove();
        return true;
    } catch (error) {
        return false;
    }
}

export const updateOrderStatus = async (table, storeID, status) => {
    try {
        await rtdb.ref(`SharedCart/${storeID}/${table}`).update(status);
        return true;
    } catch (error) {
       return false;
    }
}
